module.exports = __webpack_public_path__ + "static/media/KJSIEIT_LOGO_BLACK.273f1ce6.svg";